export default function restoreBackupReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'RESTORE_BACKUP_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'RESTORE_BACKUP_ERROR':
      return {...state, ...{error: action.error}};

    case 'RESTORE_BACKUP_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}